module.exports = __webpack_public_path__ + "img/guide.b4870c4e.png";